export default "__VITE_ASSET__W3ZRtept__"